module.exports = __webpack_public_path__ + "33c21588a22631b8bde2728190b2c699.MP3";